import React, { ReactNode, useState } from 'react';
import { Dialog, Grid, Button, Typography } from '@mui/material';
import DoNotDisturbOnIcon from '@mui/icons-material/DoNotDisturbOn';
import CustomIcon from 'components/Icon/CustomIcon';
import { useTagGroupsContext } from 'pages/TagGroups/tagGroups.context';
import { TagGroup } from '@restore/services-lib';
import { useAuthContext } from 'context/auth.context';
import { hasPermissions } from 'config/ability';
import LoadingElement from 'components/LoadingElement/LoadingElement';
import { Div } from 'components/Elements/Div/Div';

const ArchiveTagGroup = ({ tagGroup, text }: { tagGroup: TagGroup; text?: ReactNode }) => {
  const [showArchive, setShowArchive] = useState(false);
  const [loading, setLoading] = useState(false);
  const { archiveTagGroup } = useTagGroupsContext();
  const { ability } = useAuthContext();

  // Return null if user does not have 'Delete' permissions
  if (!hasPermissions(ability, 'delete', 'TagGroup')) {
    return null;
  }

  const handleArchiveTagGroup = async () => {
    setLoading(true);
    await archiveTagGroup(tagGroup.id);
    setShowArchive(false);
    setLoading(false);
  };

  return (
    <>
      <CustomIcon onClick={() => setShowArchive(true)} label={text} icon={<DoNotDisturbOnIcon />} />
      <Dialog open={showArchive} onClose={() => setShowArchive(false)}>
        <Grid container textAlign='center' p={2} spacing={1.5}>
          <Grid item xs={12}>
            <Typography variant='h5'>{tagGroup.name}</Typography>
            Are you sure you want to archive this tag group?
          </Grid>
          <Grid item xs={12}>
            <Div
              display='flex'
              width='100%'
              alignItems='flex-end'
              justifyContent='center'
              gap='0.75rem'
            >
              <Button onClick={() => setShowArchive(false)}>Cancel</Button>
              <LoadingElement
                loading={loading}
                element={<Button onClick={() => handleArchiveTagGroup()}>Archive</Button>}
              />
            </Div>
          </Grid>
        </Grid>
      </Dialog>
    </>
  );
};

export default ArchiveTagGroup;
